import { Flex, Text, TextField, Callout } from '@scale/scaleui-radix';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface WorkLimitsSelectorProps {
  dailyLimit: number | string | undefined;
  weeklyLimit: number | string | undefined;
  onDailyLimitChange: (limit: number | string | undefined) => void;
  onWeeklyLimitChange: (limit: number | string | undefined) => void;
}

export default function WorkLimitsSelector({
  dailyLimit,
  weeklyLimit,
  onDailyLimitChange,
  onWeeklyLimitChange,
}: WorkLimitsSelectorProps) {
  const handleDailyLimitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      onDailyLimitChange(undefined);
    } else {
      onDailyLimitChange(value);
    }
  };

  const handleWeeklyLimitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      onWeeklyLimitChange(undefined);
    } else {
      onWeeklyLimitChange(value);
    }
  };

  return (
    <Flex direction="column" gap="3">
      <Text size="2" weight="bold">
        Step 5: Set work hour limits
      </Text>

      <Callout.Root color="blue" size="1">
        <Callout.Icon>
          <FontAwesomeIcon icon={faInfoCircle} />
        </Callout.Icon>
        <Callout.Text>
          Leave blank to keep existing limit unchanged. Type "remove" to explicitly remove the
          limit.
        </Callout.Text>
      </Callout.Root>

      <Flex direction="column" gap="2">
        <Flex direction="column" gap="1">
          <Text size="2">Daily Limit (hours)</Text>
          <TextField.Root
            placeholder='Enter hours (e.g., "8") or "remove"'
            value={dailyLimit !== undefined ? String(dailyLimit) : ''}
            onChange={handleDailyLimitChange}
          />
          <Text size="1" color="gray">
            Maximum hours a user can work per day. Leave blank to keep current, type "remove" to
            delete.
          </Text>
        </Flex>

        <Flex direction="column" gap="1">
          <Text size="2">Weekly Limit (hours)</Text>
          <TextField.Root
            placeholder='Enter hours (e.g., "40") or "remove"'
            value={weeklyLimit !== undefined ? String(weeklyLimit) : ''}
            onChange={handleWeeklyLimitChange}
          />
          <Text size="1" color="gray">
            Maximum hours a user can work per week. Leave blank to keep current, type "remove" to
            delete.
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
